import Login from './views/Login'
import Ticket from './views/Ticket'
import Scenario from './views/Scenario'
import Outcome from './views/Outcome'
import Welcome from './views/Welcome'

import Router from 'vue-router'
import Vue from 'vue'
Vue.use(Router)
export default new Router({
    linkActiveClass: 'active',
    routes: [
      { path: '/', redirect: '/welcome' },
			{
        path: '/ticket',
        name: 'ticket',
        component: Ticket
			},
			{
        path: '/scenario',
        name: 'scenario',
        component: Scenario
			},
			{
        path: '/outcome',
        name: 'outcome',
        component: Outcome
			},
			{
        path: '/welcome',
        name: 'welcome',
        component: Welcome
      },
/*
      { path: '/lead/:id',
       component: Lead,
       name: 'Lead'
		 },
*/
     {
        path: '/login',
        name: 'login',
        component: Login
  },
    ]
  })
